import { PaginationParams } from '@/shared/types';

export abstract class UserKey {
  static ALL = ['users'];
  static CURRENT_USER = ['current-user'];
  static Roles = ['roles'];
  static LIST = [...UserKey.ALL, 'list'];
  static LIST_PAGED = (pagination: PaginationParams) => [
    ...UserKey.LIST,
    pagination,
  ];
  static ADMIN_USERS = [...UserKey.ALL, 'admin-users'];
  static ADMIN_USERS_PAGED = (
    pagination: PaginationParams,
    isAccountAdmin?: boolean,
  ) => [...UserKey.ADMIN_USERS, pagination, isAccountAdmin];

  static ORGANIZATION_ADMIN_USERS = (organizationId: number) => [
    ...UserKey.ALL,
    'organization',
    organizationId,
    'admin-users',
  ];

  static ORGANIZATION_ADMIN_USERS_PAGE = (
    organizationId: number,
    pagination: PaginationParams,
  ) => [...UserKey.ORGANIZATION_ADMIN_USERS(organizationId), pagination];

  static COMPANY_ADMIN_USERS = (companyId: number) => [
    ...UserKey.ALL,
    'company',
    companyId,
    'admin-users',
  ];

  static COMPANY_ADMIN_USERS_PAGE = (
    companyId: number,
    pagination: PaginationParams,
  ) => [...UserKey.COMPANY_ADMIN_USERS(companyId), pagination];

  static BY_ID = (userId: number) => [...UserKey.ALL, 'by-id', userId];
  static BASE_INFO = [...UserKey.ALL, 'base-info'];
  static BY_BUSINESS_AREA = (businessAreaId: number) => [
    ...UserKey.ALL,
    'business-area',
    businessAreaId,
  ];
  static BY_BUSINESS_AREA_PAGED = (
    businessAreaId: number,
    pagination: PaginationParams,
  ) => [...UserKey.BY_BUSINESS_AREA(businessAreaId), pagination];
  static BY_COMPANY = (companyId: number) => [
    ...UserKey.ALL,
    'company',
    companyId,
  ];
  static BY_COMPANY_PAGED = (
    companyId: number,
    pagination: PaginationParams,
  ) => [...UserKey.BY_COMPANY(companyId), pagination];

  static BY_ORGANIZATION = (organizationId: number) => [
    ...UserKey.ALL,
    'organization',
    organizationId,
  ];
  static BY_ORGANIZATION_PAGED = (
    organizationId: number,
    pagination: PaginationParams,
  ) => [...UserKey.BY_ORGANIZATION(organizationId), pagination];
  static BY_TASK = (taskId: number) => [...UserKey.ALL, 'by-task', taskId];
  static BY_TASK_PAGED = (taskId: number, pagination: PaginationParams) => [
    ...UserKey.BY_TASK(taskId),
    pagination,
  ];
  static BUSINESS_AREA_USERS_PROFILES = [
    ...UserKey.ALL,
    'business-area-profiles',
  ];
  static USER_RATES = (userId: number) => [...UserKey.ALL, 'rates', userId];
  static USER_RATES_PAGED = (userId: number, pagination: PaginationParams) => [
    ...UserKey.USER_RATES(userId),
    pagination,
  ];

  static ADMIN_PRIVILEGES = (userId: number) => [
    ...UserKey.BY_ID(userId),
    'admin-priviledges',
  ];

  static ADMIN_PRIVILEGES_PAGE = (
    userId: number,
    pagination: PaginationParams,
  ) => [...UserKey.ADMIN_PRIVILEGES(userId), pagination];
}
